import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import QuestionCreate from '../components/QuestionCreate';
import api from '../api';
import slugMapSelector from '../selectors/slugMapSelector';
import { getAuthenticatedAccountId } from '../selectors/auth';
import { getSelectedProfile } from '../selectors/profiles';

import { v4 as uuidv4 } from 'uuid';

class QuestionCreateContainer extends Component {
  componentDidMount() {
    this.props.questionsCreateReset({});
  }

  render() {
    const {
      accountId,
      profile,
      location,
      questionsCreate,
      questionsCreateReset,
      slugMaps
    } = this.props;

    const handleSubmit = values => {
      questionsCreateReset({});
      const { includeLocation } = values;
      const cleanedUpValues = _.omit(values, ['includeLocation']);
      cleanedUpValues.date = new Date();
      if (includeLocation) {
        cleanedUpValues.pathname = location.pathname;
      }

      questionsCreate(
        { accountId, profileId: profile.id },
        {
          body: JSON.stringify({
            id: uuidv4(),
            ...cleanedUpValues
          })
        }
      );
      this.props.onQuestionAdded();
    };

    return (
      <QuestionCreate
        onSubmit={handleSubmit}
        location={this.props.location}
        slugMaps={slugMaps}
      />
    );
  }
}

QuestionCreateContainer.propTypes = {
  accountId: PropTypes.string.isRequired,
  profile: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired,
  questionsCreate: PropTypes.func.isRequired,
  questionsCreateReset: PropTypes.func.isRequired,
  onQuestionAdded: PropTypes.func.isRequired,
  slugMaps: PropTypes.shape({
    modules: PropTypes.object,
    introPages: PropTypes.object,
    lessons: PropTypes.object
  }).isRequired,
  location: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

function mapStateToProps(state, ownProps) {
  return {
    accountId: getAuthenticatedAccountId(state),
    profile: getSelectedProfile(state),
    location: state.router.location,
    slugMaps: slugMapSelector(state),
    ...ownProps
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      questionsCreate: api.actions.questionsCreate,
      questionsCreateReset: api.actions.questionsCreate.reset
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(
  QuestionCreateContainer
);



// WEBPACK FOOTER //
// ./src/containers/QuestionCreateContainer.js